import React, { useState, useEffect } from "react";
import UserInformation from "./manageUser/UserInformation";
import UserTabs from "./manageUser/UserTabs";
import { useUserApi } from "../../services/UserApi";
import { useParams, useHistory } from "react-router-dom";
import Loader from "carbon-react/lib/components/loader";
import appRoutes from "../Navigation/appRoutes";
import { httpStatusCodes } from "../../constants/common";
import useAsyncError from "../../utils/asyncError";
import { useAppContext } from "../../contexts/AppContext";

import "./ManageUser.css";

const ManageUser = () => {
  const { id } = useParams();
  const { fetchUser } = useUserApi();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const setAsyncError = useAsyncError();
  const { userResultSet, setUserResultSet } = useAppContext();

  useEffect(() => {
    getUser();
  }, []); // eslint-disable-line

  const onUpdateUser = async (updatedUser) => {
    if (updatedUser) {
      setUser(updatedUser);
      updateCachedUser(updatedUser);
      return;
    }
    await getUser();
  };

  const updateCachedUser = (refreshedUser) => {
    const index = userResultSet?.users.findIndex(
      (usr) => usr.userId === refreshedUser?.userId
    );
    if (index < 0) return;

    userResultSet.users[index] = { ...refreshedUser };
    setUserResultSet({ ...userResultSet });
  };

  const getUser = async () => {
    try {
      const result = await fetchUser(id);
      if (!result.success || !result.data) {
        if (result.statusCode === httpStatusCodes.not_found_404) {
          history.replace(appRoutes.notFound);
          return;
        }
        throw new Error(result.error?.description || "Failed to fetch user");
      }

      setUser(result.data);
      updateCachedUser(result.data);
    } catch (error) {
      setAsyncError(error);
    }
    setLoading(false);
  };

  if (loading) return <Loader />;
  if (!user) return null;

  return (
    <>
      <UserInformation user={user} onUpdateUser={onUpdateUser} />
      <UserTabs user={user} />
    </>
  );
};

export default ManageUser;
